import React from "react";
import { TwitterPicker } from "react-color";

const colorPicker = (props) => (
  <TwitterPicker
    color={props.initialColor}
    onChangeComplete={props.colorHandler}
    colors={[
      props.initialColor,
      "#eeeeee",
      "#9e9e9e",
      "#3f51b5",
      "#00bcd4",
      "#4caf50",
      "#ff9800",
      "#f44336",
      "#9c27b0",
    ]}
  />
);

export default colorPicker;
